import { OnInit, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DwNewRouteKeyService } from '@webdpt/framework';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import * as i0 from "@angular/core";
import * as i1 from "../../../../shared/fx-http-client/http/fx-http-client";
import * as i2 from "../../../../../../../projects/webdpt/framework/components/dw-tab-routing/service/new-route-key.service";
import * as i3 from "@angular/router";
var FxUrlServiceService = /** @class */ (function () {
    function FxUrlServiceService(http, router, route) {
        this.http = http;
        this.router = router;
        this.route = route;
        this.eventEmit = new EventEmitter();
    }
    FxUrlServiceService.prototype.ngOnInit = function () {
    };
    FxUrlServiceService.prototype.getDns = function (val, id) {
        //判断入参是否为空值
        if (val === null) {
            return;
        }
        //带id域名
        var urlId = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/, 
        //完整域名
        urlDns = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/, 
        //IP地址
        urlIp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/, 
        //省www域名
        urlNameDns = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/, 
        //以http或https开头
        urlHttp = /(http|https):\/\/([\w.]+\/?)\S*/;
        var hasHttp = new RegExp(urlHttp, 'i');
        if (urlHttp.test(val) === true) {
            var newLink = val.slice(7);
            window.open("http://" + newLink);
            return;
        }
        var checkedUrl = urlId || urlDns || urlIp || urlNameDns;
        var checkUrl = new RegExp(checkedUrl, 'i');
        var text = checkUrl.test(val);
        if (text === true) {
            window.open("http://" + val);
        }
        else {
            if (id == '') {
                this.router.navigate(['./home/' + val]);
            }
            else {
                this.router.navigate(['./home/' + val, { id: id }]);
            }
        }
    };
    FxUrlServiceService.ngInjectableDef = i0.defineInjectable({ factory: function FxUrlServiceService_Factory() { return new FxUrlServiceService(i0.inject(i1.FxDapHttpClient), i0.inject(i2.DwNewRouteKeyService), i0.inject(i3.ActivatedRoute)); }, token: FxUrlServiceService, providedIn: "root" });
    return FxUrlServiceService;
}());
export { FxUrlServiceService };
